import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { schoolReportsQueryOptions } from "../../../api/billing/useSchoolReports";
import { checkOauthConnectionQueryOptions } from "../../../api/useCheckOauthConnection";
import LoadingScreen from "../../../features/Layout/LoadingScreen/LoadingScreen";
import AdminClientsOauthPage from "../../../pages/Admin/AdminClientsPage/AdminClientsOauthPage";
import AdminClientsPage from "../../../pages/Admin/AdminClientsPage/AdminClientsPage";

export const Route = createFileRoute("/(app)/admin/clients")({
  component: RouteComponent,
});

function RouteComponent() {
  const { isSuccess: pipedriveSuccess, isPending: pipedrivePending } = useQuery(
    checkOauthConnectionQueryOptions({ provider: "pipedrive" })
  );
  const { isSuccess: fortnoxSuccess, isPending: fortnoxPending } = useQuery(
    checkOauthConnectionQueryOptions({ provider: "fortnox" })
  );

  if (pipedrivePending || fortnoxPending) return <LoadingScreen />;

  if (!pipedriveSuccess || !fortnoxSuccess)
    return (
      <AdminClientsOauthPage
        authenticatedFortnox={fortnoxSuccess}
        authenticatedPipedrive={pipedriveSuccess}
      />
    );

  return <AuthenticatedClientsView />;
}

function AuthenticatedClientsView() {
  const { data: schoolReportsData } = useSuspenseQuery(
    schoolReportsQueryOptions
  );

  return <AdminClientsPage data={schoolReportsData} />;
}
